module.exports = __webpack_public_path__ + "static/media/Info.8835efaf.svg";